import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/companies/constants';
import { companiesQueryKeys } from '@/modules/companies/queries/queryKeys';
import type { ApiRequestBody } from '@/types/utils/request';
import { invalidateQuery } from '@/utils/queries';

type UpdateCompanyNoteRequestBody = ApiRequestBody<
  typeof endpoints.companyNote,
  'put'
>;
type UpdateCompanyNoteParams = {
  companyId: string;
  noteId: string;
  body: UpdateCompanyNoteRequestBody;
};

export const useUpdateCompanyNoteMutation = () => {
  return useMutation({
    mutationFn: async ({
      companyId,
      noteId,
      body,
    }: UpdateCompanyNoteParams) => {
      const { data } = await fetchClient.PUT(endpoints.companyNote, {
        params: { path: { companyId, id: noteId } },
        body,
      });

      return data;
    },
    onSettled: (_data, _error, { companyId, noteId }) => {
      invalidateQuery(companiesQueryKeys.notes(companyId))();
      invalidateQuery(companiesQueryKeys.note(companyId, noteId))();
    },
  });
};
